import React, { useEffect, useState } from 'react';
import './login-page.css'
import './signing.css'
import Logo from '../../assets/admin/HFH-logo.svg';
import { useDispatch } from 'react-redux';
import { userLogin } from '../../store/auth/actions';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from './../../authConfig';
import { getUserDetails, getUsersGroups } from "../../GraphService";
import { showLoading, hideLoading } from '../../store/loading-reducer';
import { bindActionCreators } from "@reduxjs/toolkit";
//import { User } from 'oidc-client';
 
export default function LoginPage() {
    const { instance, inProgress } = useMsal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [accessDenied, setAccessDenied] = useState(false);

    const params = new URLSearchParams(window.location.search);
    const backtologin = params.get('backtologin');
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    let data = {
        "Username": undefined,
        "Password": undefined,
        "FirstName": undefined,
        "LastName": undefined,
        "ADUniqueID": undefined
    };

    const getDetails = async () => {
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: activeAccount,
        };

        instance
            .acquireTokenSilent(accessTokenRequest)
            .then(async (accessTokenResponse) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;

                // Call your API with token
                var user = await getUserDetails(accessToken);

                var userGroups = await getUsersGroups(accessToken);

            var usersGroups = [userGroups.value.length];
                for (let i = 0; i < userGroups.value.length; i++)
            {
                usersGroups[i] = userGroups.value[i].id;
            }

                var username = user.mail;
                if (username == undefined || username == "")
                    username = user.userPrincipalName;

                if (activeAccount) {
                    data = {
                        "Username": username,
                        "Password": "Azure Authenticated",
                        "FirstName": user.givenName,
                        "LastName": user.surname,
                        "UserGroups": usersGroups,
                        "ADUniqueID": user.id
                    };
                    await hfhLogin(data);
                }
            })
            .catch((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
            });
    }

    const openLoginPopup = () => {
        if (inProgress === InteractionStatus.None && !activeAccount) {
            handleLoginRedirect();
        }
        if (accessDenied) {
            handleLoginRedirect();
        }
    }
    // Clear the server-side auth cookie whenever the login page mounts
    useEffect(() => {
        fetch('/auth/logout', { method: 'POST', credentials: 'include' })
            .catch((error) => console.log('[LoginPage] Cookie clear error:', error));
    }, []);

    // use this if you want want auto login windows at page loding
    useEffect(() => {
        if (inProgress === InteractionStatus.None && !activeAccount && backtologin === 'true') {
            handleLoginRedirect();
        }
    }, []);

    useEffect(() => {
        if (inProgress === InteractionStatus.None && activeAccount) {
            getDetails();
        }
    }, [inProgress]);

    const loginManual = bindActionCreators(userLogin, dispatch);

    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const hfhLogin = async (data) => {
        dispatch(showLoading());
        const res = await loginManual({ data }).unwrap();
        setAccessDenied(false);
        if (res && res.success) {
            dispatch(hideLoading());          
            navigate("/");
            return;
        }
        else if (res && !res.success && (res.status == "Unauthorized" || res.status == 0)) {
            dispatch(hideLoading());
            setAccessDenied(true);            
            return;
        }
        else {
            dispatch(hideLoading());
            handleLoginRedirect();
        }
    }


    return (
        <>
            <section>
                <div className="login-splash-wrap">
                    <div className="login-splash-section">
                        <img src={Logo} alt="logo" className="logo" />
                        <div>
                            <p className="login-splash-content">Appointment Reminder System</p>
                            <button className="login-splash-btn" onClick={() => openLoginPopup()}>Login</button>                          
                        </div>  
                        {accessDenied &&
                            <p className="access-denied-messagess">                               
                                <span className="material-symbols-outlined error-icon">
                                    warning
                                </span> 
                                Access Denied. Please contact your administrator concerning your access to this application.</p>
                        }
                    </div>
                </div>
            </section>
        </>
    );
}